(function () {
  const MIN_CHARS = 2;
  const DEBOUNCE_MS = 280;
  const SECTION_ID = 'wd-predictive-search';
  const LIMIT = 8;

  function escapeRegex(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightTerm(text, term) {
    if (!term) return text;
    const re = new RegExp(`(${escapeRegex(term)})`, 'gi');
    return text.replace(re, '<strong>$1</strong>');
  }

  function initSearch(root) {
    const form = root.querySelector('form');
    const input = root.querySelector('[data-wd-search-input]');
    const clearBtn = root.querySelector('[data-wd-search-clear]');
    const results = root.querySelector('[data-wd-search-results]');
    if (!form || !input || !results) return;

    let timer = null;
    let abortController = null;
    let activeIndex = -1;

    function toggleClear() {
      if (!clearBtn) return;
      clearBtn.classList.toggle('wd-hide', !input.value.length);
    }

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      root.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function openResults() {
      results.hidden = false;
      root.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
    }

    function setActiveItem(index) {
      const items = results.querySelectorAll('.wd-search-dropdown__item');
      items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      activeIndex = index;
    }

    function fetchResults(term) {
      if (!window.routes?.predictive_search_url) return;

      if (abortController) abortController.abort();
      abortController = new AbortController();

      results.innerHTML = '<div class="wd-search-dropdown__loading">Loading...</div>';
      openResults();

      const url =
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(term)}` +
        `&section_id=${SECTION_ID}&resources[type]=product&resources[limit]=${LIMIT}`;

      fetch(url, { signal: abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector(`#shopify-section-${SECTION_ID}`);
          results.innerHTML = section ? section.innerHTML : '';

          results.querySelectorAll('.wd-search-dropdown__title').forEach((el) => {
            const plain = el.textContent || '';
            el.innerHTML = highlightTerm(plain, term);
          });

          if (!results.textContent.trim()) {
            results.innerHTML = '<div class="wd-search-dropdown__empty">No products found</div>';
          }

          openResults();
        })
        .catch((error) => {
          if (error?.name === 'AbortError') return;
          closeResults();
        });
    }

    input.addEventListener('input', () => {
      toggleClear();
      const term = input.value.trim();
      clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        closeResults();
        return;
      }

      timer = setTimeout(() => fetchResults(term), DEBOUNCE_MS);
    });

    input.addEventListener('focus', () => {
      const term = input.value.trim();
      if (term.length >= MIN_CHARS && results.innerHTML && !results.hidden) {
        openResults();
      } else if (term.length >= MIN_CHARS) {
        fetchResults(term);
      }
    });

    input.addEventListener('keydown', (event) => {
      const items = results.querySelectorAll('.wd-search-dropdown__item');
      if (!items.length || results.hidden) return;

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveItem(Math.min(activeIndex + 1, items.length - 1));
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveItem(Math.max(activeIndex - 1, 0));
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        items[activeIndex].click();
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    clearBtn?.addEventListener('click', () => {
      input.value = '';
      toggleClear();
      closeResults();
      input.focus();
    });

    form.addEventListener('submit', () => {
      closeResults();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeResults();
    });
  }

  document.querySelectorAll('[data-wd-search]').forEach(initSearch);
})();
